<label *ngIf="dataset[row][colData.Name] !== undefined" [disabled]="GetDisabledValue()" nz-checkbox
    [(ngModel)]="dataset[row][colData.Name]" (ngModelChange)="valueChanged($event);"></label>
